import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  addAndUpload,
  deleteDocumentList,
  getDocumentByOpeAndRef,
  updateAndUpload,
} from "../../../api/documentUpload";
import { getBulkDropdownData } from "../../../api/keyvalue";
import { FORMS, MODULES } from "../../../const";
import DocumentUpload from "../../DocumentUpload";
import Button from "../../input/Button";

const JobUpload = ({ jobId, close }) => {
  const docRef = useRef();

  const [files, setFiles] = useState([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  const [fileNameOptions, setFileNameOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [activeOptions, setActiveOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      const {
        doc_type: docTypeData,
        "file_name#8": fileNameData,
        active: activeData,
        status: statusData,
      } = await getBulkDropdownData([
        { key: "doc_type" },
        { key: "file_name", group: "8" },
        { key: "active" },
        { key: "status" },
      ]);

      setDocumentTypeOptions(docTypeData);
      setFileNameOptions(fileNameData);
      setActiveOptions(activeData);
      setStatusOptions(statusData);

      const docData = await getDocumentByOpeAndRef(8, jobId);
      setDocuments(docData);
      setIsLoading(false);
    })();
  }, [jobId]);

  const submitHandler = async () => {
    setIsSubmitLoading(true);
    try {
      const documents = docRef.current.getData();
      if (
        documents.created.length === 0 &&
        documents.modified.length === 0 &&
        documents.deleted.length === 0
      ) {
        toast.warn(`Nothing to save or update`, {
          autoClose: 5000,
          containerId: "Modal",
        });
        setIsSubmitLoading(false);
        close(false);
        return;
      }
      let hasUploadErrors = false;
      for (let doc of documents.created) {
        const { file, ...rest } = doc;
        const formData = new FormData();
        formData.append("multipartFile", doc.file);
        formData.append("documentRequest", JSON.stringify(rest));
        formData.append("isImage", rest.docCategory === 1);
        const res = await addAndUpload(formData);
        if (res && res?.responseCode === "2040") {
          toast.success(res?.message, {
            autoClose: 5000,
            containerId: "Modal",
          });
        } else {
          hasUploadErrors = true;
          docRef.current.markUploadFailed(doc.id ?? doc.fileName);
          toast.error(res?.message || `Error adding document ${doc.docName}`, {
            autoClose: 5000,
            containerId: "Modal",
          });
        }
      }
      for (let doc of documents.modified) {
        const { file, ...rest } = doc;
        const formData = new FormData();
        formData.append("multipartFile", doc.file);
        formData.append("documentRequest", JSON.stringify(rest));
        formData.append("isImage", rest.docCategory === 1);
        const res = await updateAndUpload(formData);
        if (res && res?.responseCode === "2040") {
          toast.success(res?.message, {
            autoClose: 5000,
            containerId: "Modal",
          });
        } else {
          hasUploadErrors = true;
          docRef.current.markUploadFailed(doc.id ?? doc.fileName);
          toast.error(
            res?.message || `Error updating document ${doc.docName}`,
            {
              autoClose: 5000,
              containerId: "Modal",
            },
          );
        }
      }
      if (documents?.deleted.length > 0) {
        await deleteDocumentList({
          docIdList: documents?.deleted,
        });
        toast.success("documents deleted successfully!", {
          autoClose: 5000,
          containerId: "Modal",
        });
      }

      toast.success(`Document uploaded successfully!`, {
        autoClose: 5000,
        containerId: "Modal",
      });
      if (hasUploadErrors) {
        setIsSubmitLoading(false);
        return;
      }
      setTimeout(() => close(false), 3000);
    } catch (e) {
      console.error(e);
      toast.error(`document uploaded failed`, {
        autoClose: 5000,
        containerId: "Modal",
      });
    }
    setIsSubmitLoading(false);
  };
  return (
    <>
      <DocumentUpload
        opeType={8}
        ref={docRef}
        files={files}
        module={MODULES.Transaction}
        setFiles={setFiles}
        reference={jobId}
        dropdown={{
          documentTypeOptions,
          statusOptions,
          fileNameOptions,
          activeOptions,
        }}
        isLoading={isLoading}
        editMode={true}
        currentValues={documents}
        isOnTheModal={true}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          justifyContent: "flex-end",
          gap: "5px",
          marginTop: "10px",
        }}
      >
        <Button
          template="create"
          onClick={submitHandler}
          isLoading={isSubmitLoading}
          module={MODULES.Transaction}
          form={FORMS.JOB.DOCUMENT.form}
          authenticated={true}
          editMode={true}
        />
      </div>
    </>
  );
};

export default JobUpload;
